









import { Component, Vue } from 'vue-property-decorator'
import { VQuery, VTable, QueryModel, TableHander, TableOperation } from '@/components/table'
import { DeleteMemberConfig, QueryMemberConfigList, UpdateMemberConfigStatus,QueryMemberAllList } from '@/api'
import { DateFormat } from '@/utils/date/DateUtil'
import { Message, MessageBox } from 'element-ui'
import EditMemberConfigDialog from './EditMemberConfigDialog.vue'
import { MemberStatusFormat} from '@/utils/tyepconvert'

@Component({
  components: {
    VQuery,
    VTable,
    EditMemberConfigDialog,
  },
})
export default class VideoList extends Vue {
  private queryParam = {
    startRow: 1,
    limit: 10,
  }
  private tableTotal = 0
  private tableData = []
  private tableCurrntPage = 1

  // 查询条件
  private memberQueryParam:QueryModel =  { title: '会员', param: 'memberId', type:"select",selectData: [] }
  private queryModels: Array<QueryModel> = [
    this.memberQueryParam,
    { title: '层级', param: 'level' },
  ]
  // 全局操作
  private queryOperation: Array<TableOperation> = [{ title: '创建代理', type: 'primary', click: this.openCreateVideo }]
  // 数据表头 -
  // 视频比例 ()
  private tableHander: Array<TableHander> = [
    { title: '序号', param: 'id', type: 'index' },
    { title: '会员名称', param: 'memberName' },
    { title: '层级', param: 'level' },
    { title: '比例', param: 'commissionRate' },
    { title: '状态', param: 'status' , formatter: MemberStatusFormat},
    {
      title: '操作',
      operation: [
        { title: '编辑', click: this.openEditVideo },
        {
          title: '启用',
          click: this.updateOpenStatus,
          show: function (data) {
            return data.status != 1
          },
        },
        {
          title: '禁用',
          click: this.updateCloseStatus,
          show: function (data) {
            return data.status == 1
          },
        },
        // { title: '删除', click: this.delete },
      ],
    },
  ]

  public async created() {
    this.loadData()
    this.loadMember()
  }

  private loadMember(){
    // 加载会员
    QueryMemberAllList().then(res=>{
      this.memberQueryParam.selectData = res.map((e: any)=>{
        return {value: e.id,label:e.name}
      })
    })
  }

  private openCreateVideo() {
    const d = this.$refs.EditMemberConfigDialog as EditMemberConfigDialog
    d.open({}, false)
  }

  private delete(data: any) {
    if(data.id == 1){
       Message.error('默认会员代理设置不能删除')
      return;
    }
    MessageBox.confirm('确定要删除吗？', '提示', {
      type: 'warning',
    }).then(async () => {
      const ruslt = await DeleteMemberConfig({ id: data.id })
      if (ruslt) {
        Message.success('删除成功')
        this.loadData()
      }
    })
  }

  private async updateOpenStatus(data: any) {
    await UpdateMemberConfigStatus({
      id: data.id,
      status: 1,
    })
    this.loadData()
  }
  private async updateCloseStatus(data: any) {
    await UpdateMemberConfigStatus({
      id: data.id,
      status: 0,
    })
    this.loadData()
  }

  public openEditVideo(data: any) {
    const d = this.$refs.EditMemberConfigDialog as EditMemberConfigDialog
    d.open(data, true)
  }

  public async loadData() {
    const param = { ...this.queryParam }
    param.startRow =  (this.tableCurrntPage - 1) * (param.limit || 12)
    const result = await QueryMemberConfigList(param)
    this.tableTotal = result.total
    this.tableData = result.list
  }

  public search() {
    console.log(this.queryParam)
    this.tableCurrntPage = 1
    this.loadData()
  }
  // 分页导航改变
  public pageChange(index: number) {
    this.tableCurrntPage = index
    this.loadData()
  }

  public sizeChange(index: number) {
    this.tableCurrntPage = 1
    this.queryParam.limit = index
    this.loadData()
  }
}
